import React from "react"
import styled from "styled-components"

import { Container, Row, Col } from "./Grid"
import Link from "../components/Link"
import Button from "./Button"

import { media, mixins } from "../styles"

const HeroContainer = styled.div`
  align-items: center;
  display: flex;
  font-weight: 300;
  min-height: 380px;
  justify-content: center;
  text-align: center;
  position: relative;
  z-index: 1;

  @media ${media.md} {
    height: 480px;
  }

  @media ${media.xl} {
    height: 660px;
  }

  p {
    ${mixins.copy2}
    margin-bottom: 20px;
  }

  .button {
    @media ${media.sm} {
      margin-top: 5px;
    }
  }
`

const Header = styled.div`
  height: 380px;
  margin: 0 0 30px;
  padding: 65px 0px 0px;
  z-index: 1;
  position: relative;

  @media ${media.sm} {
    padding: 100px 0px 0px;
  }

  @media ${media.md} {
    height: auto;
    margin: 20px 0 20px;
    padding: 25px 0px 0px;
  }

  @media ${media.xxl} {
    padding: 25px 100px 0px;
  }

  h1 {
    ${mixins.title1}
    margin: 0;
  }
`

const Background = styled.div`
  height: 380px;
  background: var(--color-greyWarm);
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: -1;

  @media ${media.md} {
    height: 480px;
  }

  @media ${media.xl} {
    height: 660px;
  }
`

const HeroSimple = (props) => {
  const { buttonOverride, header, text, linkText, linkUrl } = props
  return (
    <Container>
      <HeroContainer>
        <Row>
          {header && (
            <Col
              col="10"
              xsOffset="1"
              sm="10"
              smOffset="1"
              md="8"
              mdOffset="2"
              lg="6"
              lgOffset="3"
              xl="10"
              xlOffset="1"
            >
              <Header>
                <h1>{header}</h1>
              </Header>
            </Col>
          )}

          <Col
            col="10"
            xsOffset="1"
            sm="10"
            smOffset="1"
            md="6"
            mdOffset="3"
            xl="6"
            xlOffset="3"
          >
            {text && text}
            {buttonOverride && buttonOverride}
            {!buttonOverride && linkText && linkUrl && (
              <Button as={Link} to={linkUrl} arrow intl={false}>
                {linkText}
              </Button>
            )}
          </Col>
        </Row>
        <Background aria-hidden={true}>{props.background}</Background>
      </HeroContainer>
    </Container>
  )
}

export default HeroSimple
